import { notSelectedValue } from "@pages/shops/[uuid]/request_reservation";
import { Text } from "@components/Text";
import { PredefinedToolTips, ToolTip } from "@components/ToolTip";
import { ReservationFormRow } from "@components/pages/shops/[uuid]/request_reservation/ReservationFormRow";
import { ReservationFormSelect } from "@components/pages/shops/[uuid]/request_reservation/ReservationFormSelect";
import type { UsersTeamType } from "@graphql/__generated__/types";
import type { FC } from "react";

type Props = {
  homeTeam: Pick<UsersTeamType, "id" | "name"> | null | undefined;
  awayTeam: Pick<UsersTeamType, "id" | "name"> | null | undefined;
};

export const ReservationFormSupportingTeamRow: FC<Props> = ({
  homeTeam,
  awayTeam,
}) => {
  const hasTbaTeam = !homeTeam || !awayTeam;
  return (
    <ReservationFormRow
      title="応援するチーム"
      toolTip={
        <ToolTip toolTip={PredefinedToolTips.reservationSupportingTeam} />
      }
    >
      {hasTbaTeam ? (
        <Text size={15}>チーム未定のため選択できません</Text>
      ) : (
        <ReservationFormSelect name={"supportingTeamId"} required={false}>
          <option value={notSelectedValue} disabled>
            選択してください
          </option>
          {homeTeam && (
            <option value={homeTeam.id.toString()}>{homeTeam.name}</option>
          )}
          {awayTeam && (
            <option value={awayTeam.id.toString()}>{awayTeam.name}</option>
          )}
          <option value={"0"}>どちらでもない</option>
        </ReservationFormSelect>
      )}
    </ReservationFormRow>
  );
};
